var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Partner/CommercialApi/ConfirmPartnerConnection/index.tsx";
import React, { useMemo, useState } from 'react';
import { Divider, HStack, IconInfo, Stack, Text, ToggleListItem } from '@adc/parallax-component-library';
import { useApiError, useConnection, useLibrePartner } from 'Hooks';
import { Button, Footer, InfoModal, Main, RichText, ScrollContainer, Spinner, TitleActionBar } from 'Components/utility';
import { getDocumentPathFromLanguage } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const InfoComponent = ({
  scopes,
  scopesStr,
  handleClickInfoBtn,
  title,
  toggleOnPress,
  toggleState
}) => {
  return /*#__PURE__*/React.createElement(Stack, {
    margin: "$4",
    marginTop: "$2",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ToggleListItem, {
    title: title,
    onPress: toggleOnPress,
    checked: toggleState,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Divider, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  }), scopes.map((_, idx) => /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "$4",
    marginBottom: "$4",
    marginHorizontal: "$4",
    key: scopesStr[idx],
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ConfirmConnection.scopes",
    color: "$text.100",
    fontWeight: "$bodyBase.medium",
    fontSize: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 11
    }
  }, scopesStr[idx]), /*#__PURE__*/React.createElement(Stack, {
    onPress: () => handleClickInfoBtn(idx),
    cursor: "pointer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(IconInfo, {
    testID: "ConfirmConnection.info-icon",
    size: "S",
    color: "$interactive.core.enabled",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 13
    }
  })))));
};
var LINKS = /*#__PURE__*/function (LINKS) {
  LINKS["TERMS_OF_USE"] = "/terms-of-use";
  LINKS["PRIVACY_NOTICE"] = "/privacy-notice";
  LINKS["LIBRE_TERMS_OF_USE"] = "/terms-of-use-libre";
  LINKS["LIBRE_PRIVACY_NOTICE"] = "/privacy-notice-libre";
  return LINKS;
}(LINKS || {});
const ConfirmPartnerConnection = ({
  data: {
    partnerConnection,
    code,
    yearOfBirth
  }
}) => {
  const [loading, setLoading] = useState(false);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [scopeSelected, setScopeSelected] = useState('');
  const [shareDataToggle, setShareDataToggle] = useState(false);
  const isHealthData = scopeSelected === 'healthdata';
  const {
    showApiErrorModal
  } = useApiError();
  const {
    acceptOrRejectPartnerConnection
  } = useLibrePartner();
  const {
    getConnections
  } = useConnection();
  const scopes = useMemo(() => [...new Set(partnerConnection?.consent.scopes.reduce((acc, scope) => {
    const splittedScope = scope.split('.');
    if (splittedScope.length > 1) {
      acc.push(splittedScope[1]);
    }
    return acc;
  }, []))], [partnerConnection?.consent.scopes]);
  const scopesStr = useMemo(() => {
    const scopeStrArr = scopes.map(key => {
      const scopeRaw = i18n.t(`Global.microcopy.scopes.${key}`).toLowerCase();
      return scopeRaw.charAt(0).toUpperCase() + scopeRaw.slice(1);
    });
    return scopeStrArr;
  }, [scopes]);
  if (!partnerConnection) {
    mediator.publish('router:navigate', '/connections');
    return null;
  }
  const handleClickInfoBtn = idx => {
    setScopeSelected(scopes[idx]);
    setShowModalInfo(true);
  };
  const onLibreDocumentLinkClick = (document = 'pn') => {
    const {
      documentsUrl,
      documents
    } = store.getState().config;
    const {
      language
    } = store.getState().lang;
    const documentPath = document === 'tou' ? getDocumentPathFromLanguage(documents?.toupat, language) : getDocumentPathFromLanguage(documents?.privacypolicy, language);
    if (documentPath) {
      const privacyNoticeFullUrl = `${documentsUrl}${documentPath}`;
      window.open(privacyNoticeFullUrl, '_blank');
    }
  };
  const onLinkClick = data => {
    if (data === LINKS.PRIVACY_NOTICE) {
      window.open(partnerConnection.partner.privacyNotice, '_blank');
    }
    if (data === LINKS.TERMS_OF_USE) {
      window.open(partnerConnection.partner.termsOfUse, '_blank');
    }
    if (data === LINKS.LIBRE_TERMS_OF_USE) {
      onLibreDocumentLinkClick('tou');
    }
    if (data === LINKS.LIBRE_PRIVACY_NOTICE) {
      onLibreDocumentLinkClick();
    }
  };
  const onAcceptOrDeclineConnection = async action => {
    if (partnerConnection) {
      setLoading(true);
      const {
        error
      } = await acceptOrRejectPartnerConnection(partnerConnection.partner.id, action, code, yearOfBirth);
      if (error) {
        showApiErrorModal();
        setLoading(false);
        return;
      }
      const connections = await getConnections();
      const connection = connections.partnerConnections?.find(pc => pc.partner.id === partnerConnection.partner.id);
      mediator.publish('router:navigate', {
        url: '/partner-connection',
        data: {
          partnerConnection: connection
        }
      });
      setLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 217,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "ConfirmConnection",
    title: i18n.t('DataSharingCommercialApi.title'),
    closeBtn: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218,
      columnNumber: 7
    }
  }), loading && /*#__PURE__*/React.createElement(Spinner, {
    "aria-label": "loading",
    testID: "ConfirmConnection.spinner",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    marginTop: 19,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 224,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ConfirmConnection.secondaryText",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    lineHeight: "$bodyBase.default",
    color: "$text.100",
    marginHorizontal: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 225,
      columnNumber: 9
    }
  }, i18n.t('DataSharingCommercialApi.content.dataShareTile.primaryText', {
    partnerName: partnerConnection.partner.name
  })), /*#__PURE__*/React.createElement(InfoComponent, {
    handleClickInfoBtn: handleClickInfoBtn,
    scopes: scopes,
    title: i18n.t('DataSharingCommercialApi.content.dataShareTile.secondaryText', {
      partnerName: partnerConnection.partner.name
    }),
    toggleOnPress: () => setShareDataToggle(oldState => !oldState),
    toggleState: shareDataToggle,
    scopesStr: scopesStr,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 237,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    marginHorizontal: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 247,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 248,
      columnNumber: 11
    }
  }, !partnerConnection?.partner.hideDisclaimer && /*#__PURE__*/React.createElement(RichText, {
    text: i18n.t('DataSharingCommercialApi.content.dataSharePolicy.secondaryText', {
      partnerName: partnerConnection?.partner.name
    }),
    color: "$text.60",
    testID: "ConfirmConnection.secondaryText",
    fontToken: "$labelBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 250,
      columnNumber: 15
    }
  })), partnerConnection?.partner.privacyNotice && partnerConnection?.partner.termsOfUse && /*#__PURE__*/React.createElement(RichText, {
    text: i18n.t('DataSharingCommercialApi.content.dataSharePolicy.bodyText', {
      partnerName: partnerConnection?.partner.name
    }),
    color: "$text.60",
    testID: "ConfirmConnection.bodyText",
    onPressLink: onLinkClick,
    fontToken: "$labelBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 261,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: "",
    customProps: /*#__PURE__*/React.createElement(Stack, {
      marginHorizontal: "$3",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 276,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(HStack, {
      justifyContent: "space-between",
      marginTop: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 277,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Button, {
      marginRight: "$2",
      onPress: () => onAcceptOrDeclineConnection('decline'),
      testID: "ConfirmConnection.common.decline",
      "aria-label": i18n.t('Global.microcopy.common.decline'),
      label: i18n.t('Global.microcopy.common.decline'),
      flexGrow: 1,
      variant: "secondary",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 278,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(Button, {
      marginLeft: "$2",
      onPress: () => onAcceptOrDeclineConnection('accept'),
      testID: "ConfirmConnection.common.allow",
      "aria-label": i18n.t('Global.microcopy.common.allow'),
      label: i18n.t('Global.microcopy.common.allow'),
      flexGrow: 1,
      disabled: !shareDataToggle,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 287,
        columnNumber: 15
      }
    }))),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 273,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(InfoModal, {
    isOpen: showModalInfo,
    title: isHealthData ? i18n.t('ConnectedOAuthPartner.modals.healthDataSharedBottomSheet.title') : i18n.t(`DataSharingCommercialApi.modals.typesOfDataBottomSheet.title`),
    customBody: isHealthData ? /*#__PURE__*/React.createElement(Stack, {
      key: scopeSelected,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 309,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Stack, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 310,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(RichText, {
      onPressLink: onLibreDocumentLinkClick,
      fontToken: "$bodySmall.default",
      testID: `ConfirmConnection.scope.${scopeSelected}.description`,
      text: i18n.t('ConnectedOAuthPartner.modals.healthDataSharedBottomSheet.body'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 311,
        columnNumber: 17
      }
    }))) : /*#__PURE__*/React.createElement(Stack, {
      key: scopeSelected,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 320,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Text, {
      testID: `ConfirmConnection.scope.${scopeSelected}`,
      marginBottom: "$2",
      color: "$text.100",
      fontWeight: "$bodyBase.strong",
      fontSize: "$bodyBase.strong",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 321,
        columnNumber: 15
      }
    }, `${i18n.t(`Connections.modals.dataSharingBottomSheet.${scopeSelected}Title`)}`), /*#__PURE__*/React.createElement(RichText, {
      fontToken: "$bodySmall.default",
      testID: `ConfirmConnection.scope.${scopeSelected}.description`,
      text: i18n.t(scopeSelected === 'glucose' && partnerConnection.consent.currentGlucose ? 'Connections.modals.dataSharingBottomSheet.glucose_cg' : `Connections.modals.dataSharingBottomSheet.${scopeSelected}`),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 331,
        columnNumber: 15
      }
    })),
    handleClose: () => setShowModalInfo(false),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 300,
      columnNumber: 7
    }
  }));
};
export default ConfirmPartnerConnection;